import { sync } from '@genesislcap/foundation-utils';
import { html, repeat, ref, when, slotted } from '@microsoft/fast-element';
import { whitespaceFilter } from '@microsoft/fast-foundation';
import { classNames } from '@microsoft/fast-web-utilities';
import { MultiselectDatasource } from '../options-datasource';
const ARROW_SVG_PATH = 'M11.85.65c.2.2.2.5 0 .7L6.4 6.84a.55.55 0 01-.78 0L.14 1.35a.5.5 0 11.71-.7L6 5.8 11.15.65c.2-.2.5-.2.7 0z';
export const getPrefixedMultiselect = (prefix = 'foundation') => html `
  <label
    part="label"
    for="control"
    class=${(x) => { var _a; return classNames('label', ['label-hidden', !((_a = x.defaultSlottedNodes) === null || _a === void 0 ? void 0 : _a.length)]); }}
  >
    <slot
      name="label"
      ${slotted({
    property: 'defaultSlottedNodes',
    filter: whitespaceFilter,
})}
    ></slot>
  </label>
  <div class="root" part="root">
    <div class="control" part="control">
      <div part="indicator" class="indicator" @click=${(x) => !x.disabled && x.toggle()}>
        <svg
          viewBox="0 0 12 7"
          ${ref('arrowIcon')}
          id="arrow-icon"
          class="${(x) => classNames(['disabled-svg', x.disabled])}"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="${ARROW_SVG_PATH}" />
        </svg>
      </div>

      <input
        part="input"
        readonly
        type="text"
        id="display-field"
        part="display-field"
        :value="${(x) => x.getDisplayValue}"
        :disabled="${(x) => x.disabled}"
        @click=${(x) => x.toggle()}
      />
    </div>
    <div ${ref('optionsElement')} class="options">
      ${when((x) => x.search, html `
          <${prefix}-text-field
            id="filter-search"
            part="filter-search"
            value=${sync((x) => x.filterSearchValue, 'string', 'input')}
            placeholder="${(x) => x.getPlaceholder}"
            @input=${(x, c) => x.inputHandler()}
            @change=${(x, c) => x.changeHandler(c.event)}
          ></${prefix}-text-field>
        `)}
      <div class="checkbox-container">
        ${when((x) => x.loading, html `
            <${prefix}-progress slot="indicator"></${prefix}-progress>
          `)}
        ${when((x) => x.all, html `
            <${prefix}-checkbox
              @click=${(x) => x.selectCheckboxAll()}
              @change=${(x, c) => x.changeHandler(c.event)}
              ?current-checked="${(x) => x.isAllSelected}"
              ?disabled="${(x, c) => x.isAllOptionsDisabled}"
            >
              All ${(x) => x.name}
            </${prefix}-checkbox>
          `)}
        ${repeat((x) => x.filteredAvailableOptions, html `
            <${prefix}-checkbox
              @click=${(x, c) => c.parent.selectCheckboxOne(x)}
              @change=${(x, c) => c.parent.changeHandler(c.event)}
              ?current-checked="${(x, c) => c.parent.isOptionSelected(x)}"
              ?disabled="${(x, c) => c.parent.isOptionDisabled(x)}"
            >
              ${(x, ctx) => ctx.parent.getItemLabel(x)}
            </${prefix}-checkbox>
          `)}
      </div>
    </div>
  </div>
  <slot
    ${slotted({
    property: 'slottedDatasource',
    filter: (x) => x instanceof MultiselectDatasource,
})}
  ></slot>
`;
export const multiselectTemplate = html `
  ${getPrefixedMultiselect()}
`;
